module.exports = __webpack_public_path__ + "img/Logo.d4548f4c.png";